// Mirrors the localStorage key used by WorkspaceContext so the active workspace
// persists across navigations (e.g. after accepting an invite, so the user
// lands in the invited workspace on /app/studio rather than their previous one).
export function rememberActiveWorkspace(userId: string, workspaceId: string): void {
  localStorage.setItem(`workspace_${userId}`, workspaceId);
}
